<template>
  <div v-if="loaded">
    <header-component v-if="company" :company="company" />
    <main class="billing">
      <router-view />
      <loader-component v-show="loading" />
    </main>
  </div>
</template>

<script>
import LoaderComponent from "../../shared/components/LoaderComponent";
import HeaderComponent from "../../core/header/HeaderComponent.vue";
export default {
  name: "SubscriptionComponent",
  components: {
    LoaderComponent,
    HeaderComponent,
  },
  computed: {
    loaded() {
      return this.$store.state.loaded;
    },
    loading() {
      return this.$store.state.loading;
    },
    company() {
      return this.$store.state.company;
    },
  },
  mounted() {
    const initialLoader = document.getElementById("initial-loader");
    if (initialLoader !== undefined && initialLoader !== null) {
      initialLoader.remove();
    }
  },
};
</script>

<style lang="scss">
/* @media queries */
@mixin tabletAndMobile {
  @media (max-width: 767px) {
    @content;
  }
}
/* End of: @media queries */

main.billing {
  padding-top: 141px;
  height: auto;
  min-height: 100vh;
  margin-top: 0;
  background-color: rgba(243, 243, 243, 0.75);

  .section-title {
    font-size: 1.5rem;
    line-height: 2rem;
    margin-bottom: 28px;
  }

  .billing-wrapper {
    max-width: 1166px;
    margin: 0 auto;
    form {
      width: 100%;
      display: flex;
      flex-direction: row;
      align-items: flex-start;
    }

    .plan-options {
      .option {
        .radio-wrap {
          width: 100%;
          .custom-control {
            padding-left: 0;
          }
          .custom-control-label {
            display: flex;
            width: 100%;
            flex-direction: row;
            align-items: center;
            padding: 13px 38px 13px 64px;
            min-height: 96px;
            cursor: pointer;

            &:before {
              top: 50%;
              margin-top: -12px;
              left: 40px;
            }
            &:after {
              top: 50%;
              margin-top: -6px;
              left: 46px;
            }
          }
        }

        .plan {
          position: relative;
          padding-left: 16px;
          h3 {
            font-size: 1.5rem;
            line-height: 2rem;
            color: #262626;
          }

          span {
            font-family: "Roboto", sans-serif;
            font-size: 0.875rem;
            font-weight: 400;
            line-height: 1.5rem;
            color: #999;

            position: absolute;
            width: 200px;
            left: auto;
            bottom: -22px;
          }
        }

        .pricing {
          display: flex;
          flex-direction: row;
          margin-left: auto;

          h3 {
            font-size: 1.875rem;
            line-height: 2rem;
            color: #262626;
            margin-right: 18px;
          }

          span {
            display: inline-flex;
            font-family: "Roboto", sans-serif;
            font-size: 1.25rem;
            line-height: 2rem;
            margin-top: -1px;
            color: #262626;
            font-weight: 400;
          }
        }

        &.selected {
          border: 2px solid #00b9cb;
        }

        &:last-child {
          margin-bottom: 0;
        }
      }
    }
  }

  .billing-container {
    margin: 0 10.5px;
    padding: 28px 41px 41px 41px;
    min-height: 70vh;
    background-color: #fff;
    display: inline-flex;
    flex-grow: 1;
    flex-direction: column;
    border: 1px solid #efefef;
    box-shadow: 1px 2px 4px 0 rgba(199, 199, 199, 0.5);

    p {
      margin-bottom: 42px;
      font-size: 0.875rem;
      line-height: 1.25rem;
      font-family: "Roboto", sans-serif;
      color: #999;
    }
    .atto-form {
      .field-row {
        .atto-select {
          .select-options {
            .heading {
              span {
                font-weight: 400;
              }
            }
            .options {
              ul {
                li {
                  font-weight: 400;
                }
              }
            }
          }
        }
      }
    }
  }

  .select-plan {
    margin: 0 10.5px;
    padding: 28px 41px 41px 41px;
    background-color: #fff;
    display: inline-flex;
    flex-grow: 1;
    border: 1px solid #efefef;
    box-shadow: 1px 2px 4px 0 rgba(199, 199, 199, 0.5);
  }

  .billing-wrap {
    width: 362px;
    margin: 0 10.5px;
    display: inline-flex;
    flex-direction: column;
  }

  .billing-sidebar {
    padding: 28px 41px 41px 41px;
    background-color: #fff;
    display: flex;
    border: 1px solid #efefef;
    box-shadow: 1px 2px 4px 0 rgba(199, 199, 199, 0.5);
    flex-direction: column;

    h3.sidebar-title {
      font-size: 1.5rem;
      line-height: 2rem;
      margin-bottom: 0;
    }

    .sidebar-subtitle {
      font-size: 1.125rem;
      line-height: 2rem;
      font-weight: 500;
      color: #00b9cb;
      font-family: "Roboto", sans-serif;
      /*margin-bottom: 27px;*/
      text-transform: capitalize;
    }

    .field-row {
      display: flex;
      flex-direction: row;
      align-items: center;
      margin-bottom: 16px;

      h5.field-label {
        font-family: "Roboto", sans-serif;
        font-size: 1rem;
        line-height: 1.5rem;
        font-weight: 500;
        color: #999;
        display: inline-flex;
        width: 50%;
      }

      span.value {
        display: inline-flex;
        width: 50%;
        justify-content: flex-end;
        font-size: 1rem;
        line-height: 1.5rem;
        font-family: "Roboto", sans-serif;
        font-weight: 500;
        color: #999;
      }

      &.total {
        margin-top: 9px;
        margin-bottom: 0;

        h5.field-label,
        span.value {
          font-size: 1.125rem;
          line-height: 2rem;
          color: #262626;
        }
      }
    }

    hr.break-line {
      width: 100%;
      height: 2px;
      background-color: #efefef;
      margin: 28px 0;
      border: 0;

      &.bottom {
        margin: 28px 0 40px;
      }
    }

    button.atto-btn {
      justify-content: center;
      text-transform: uppercase;
    }
  }

  .billing-info {
    padding: 32px 41px;
    p {
      font-size: 0.75rem;
      line-height: 1rem;
      font-weight: 400;
      font-family: "Roboto", sans-serif;
      color: #999;
      a {
        font-weight: 500;
        text-decoration: underline;

        &:hover {
          color: #262626;
        }
      }
      span.date {
        font-weight: bold;
      }
    }
  }
}

@media only screen and (max-width: 768px) {
  main.billing {
    padding-top: 80px;

    .billing-wrapper {
      max-width: 100%;
      form {
        flex-direction: column;
        padding: 0 10px;
      }

      .billing-container {
        width: 100%;
        margin: 0 auto 24px;
        padding: 30px 25px;
      }

      .plan-options {
        .error {
          margin-left: 62px;
        }

        .option {
          .radio-wrap {
            .custom-control-label {
              padding: 16px 20px;
              flex-direction: column;
              &:before {
                top: 32px;
                left: 20px;
              }
              &:after {
                top: 32px;
                left: 26px;
              }
            }
          }
          .plan {
            padding-left: 40px;
            span {
              position: relative;
              left: auto;
              bottom: auto;
              margin-top: 0;
            }
          }

          .pricing {
            h3 {
              margin-right: 8px;
            }
          }
        }
      }
    }

    .billing-wrap {
      width: 100%;
      margin: 0 0 96px;

      .billing-sidebar,
      .billing-info {
        padding: 30px 25px;
      }
    }

    .atto-form {
      .field-row {
        flex-direction: column;
        margin-bottom: 15px;
        .half {
          width: 100%;
          margin-right: 0;
          margin-bottom: 15px;
          .field-wrap {
            margin-bottom: 0;
            &:first-child:not(:only-child) {
              margin-right: 16px;
            }
          }

          &.m-mb-0 {
            margin-bottom: 0;
          }
        }
        .field-wrap {
          width: 100%;
          margin-right: 0;
          margin-bottom: 15px;

          &:last-child {
            margin-bottom: 0;
          }
        }
      }
    }
  }

  .modal-invite-member {
    margin: 0 auto;
    max-width: 100%;
    min-height: 100vh;

    .modal-content {
      .modal-body {
        .modal-head {
          padding: 20px 20px 3px;
          .manage-team-anchor {
            display: none;
          }
        }

        .content-wrapper {
          padding: 12px 20px !important;

          .head-labels {
            .label:not(.email) {
              display: none;
            }
          }

          .field-row {
            .email-wrap {
              margin-right: 0;
            }

            .role-wrap {
              display: none;
            }
          }
        }

        .modal-footer {
          padding: 3px 20px 20px;

          .form-buttons {
            flex-direction: column;
            @include tabletAndMobile {
              width: 100%;
            }
            button {
              width: 100%;
              margin-right: 0;
              margin-bottom: 8px;

              &.submit {
                order: -1;
              }

              &.cancel {
                margin-bottom: 0;
                margin-top: 0;
              }
            }
          }

          .form-disclaimer.bottom {
            max-width: 100%;
          }
        }
      }
    }
  }

  #purchase-seats {
    .modal-invite-member {
      .modal-content {
        min-height: 100vh;
      }
    }
  }
}

@media only screen and (max-width: 768px) and (orientation: landscape) {
  .modal-invite-member {
    .modal-content {
      .modal-body {
        .modal-head {
          padding: 46px 48px 8px;
        }
        .content-wrapper {
        }
        .modal-footer {
          padding: 8px 48px 48px;
          .form-buttons {
            flex-direction: row;
            button {
              &.cancel {
                margin-right: 12px;
                margin-top: 0;
              }
              &.submit,
              &.delete {
                order: 2;
                margin-bottom: 0;
                margin-top: 0;
              }
            }
          }
        }
      }
    }
  }
}

@media only screen and (min-width: 664px) and (max-width: 1024px) and (orientation: landscape) {
  main.billing {
    .billing-wrapper {
      max-width: 100%;
      form {
        flex-direction: column;
        align-items: center;
        .atto-form {
          .field-row {
            .half {
              margin-right: 0px;
            }
            .field-wrap {
              margin-right: 16px;
            }
          }
        }
      }
      .billing-container {
        width: 66.66667%;
        padding: 24px 30px;
        margin-bottom: 24px;
      }

      .billing-wrap {
        width: 66.66667%;
        margin-bottom: 96px;
        .billing-sidebar {
          padding: 24px 30px;
        }
      }
    }
  }
}

@media (min-width: 768px) and (max-width: 1024px) {
  .settings-page {
    .container-wrap {
      padding-left: 0;
    }
  }
}
</style>
